<template>
  <div class="wholeDetail">
    <div class="nav">
      <van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
      <span>我要整装租赁</span>
      <div></div>
    </div>
    <van-form @submit="onSubmit">
      <div class="main">
        <van-panel title="请根据您的需求配置以下选项">
          <div v-if="isNext">
            <div v-for="(v,x) in list" :key="x" class="main_content">
              <div class="mian-title">{{x+1}}.{{v.title}}：</div>
              <div v-for="(vs,xs) in v.whole_category" :key="xs" @click.prevent="isSelect(x,xs)" class="main-content-list"
                :class="{'popup-active': listSelectArr[x].curSelectIndex == xs}">
                <img :src="vs.image | handleUrl" alt="">
                <div class="router" @click="goDeploy(xs)">[查看配置]</div>
                <span v-if="listSelectArr[x].curSelectIndex == xs">{{vs.price}}元/m²/月</span>
              </div>
            </div>
            <van-field class="ads" name="面积" v-model="number" type="number" label="输入房屋面积" placeholder="请输入大于等于100的数值">
              <div slot="right-icon" style="color:#000">m²</div>
            </van-field>
            <div class="term">选择您的租赁期限</div>
            <van-field name="租赁期限" class="term_date">
              <template #input>
                <van-radio-group v-model="radio" icon-size="15px">
                  <van-radio name="1">12个月</van-radio>
                  <van-radio name="2">24个月<span style="color:#F1452F">(租24个月送12个月)</span></van-radio>
                  <van-radio name="3">36个月<span style="color:#F1452F">(租36个月送36个月)</span></van-radio>
                </van-radio-group>
              </template>
            </van-field>
            <van-button round type="info" size="small" color="#F1452F" @click.prevent="next" style="width:94%;margin-top:0.5rem">下一步
            </van-button>
          </div>
          <div v-else style="padding-bottom:2.5rem">
            <div class="tips">
              如果以上无法满足您的需求,请联系<span @click="_open53">在线客服</span>或致电线下服务商:400-8722-000
            </div>
            <div class="msg">
              <div class="notes">请填写您的联系信息</div>
              <van-field class="ads" v-model="user" name="real_name" label="联系人:" placeholder="请输入联系人" />
              <van-field class="ads" v-model="tel" name="tel" label="联系电话:" placeholder="请输入电话" />
              <van-field class="ads" v-model="address" name="province">
                <div slot="label">省市区:</div>
                <van-cell class="address" slot="input" :title="address" is-link @click="select=true" />
              </van-field>
              <van-field class="ads" name="address" v-model="city" label="项目地址:" placeholder="请输入具体地址" />
            </div>
            <div class="total">
              <span class="text_c">月租金¥{{lease}}/m²</span>
              <span class="text_a">总价:</span>
              <span class="text_b">¥{{total}}</span>
              <span style="font-size:0.8rem">(</span><span class="text_c">含可退押金¥{{mortgage_total}}</span><span style="font-size:0.8rem">)</span>
            </div>
            <div class="code">
              <van-field class="ads" v-model="userCode" name="payment_user" label="付款码:" placeholder="请输入商户会员编号" />
            </div>
            <div class="notes">备注信息</div>
            <van-field class="notes_msg" v-model="message" name="order_message" rows="1" autosize type="textarea"
              placeholder="请留下您的特别说明" />
            <van-button round type="info" size="small" plain color="#F1452F" @click.prevent="isNext=true;total=0" style="width:94%;margin-top:0.5rem">上一步</van-button>
            <van-goods-action>
              <van-goods-action-icon icon="wap-home-o" text="首页" to="/home" />
              <van-goods-action-icon icon="phone-o" text="客服" @click="_open53" />
              <van-goods-action-button type="warning" text="对公转账" native-type="submit" @click="duig=true" />
              <van-goods-action-button type="danger" text="立即支付" native-type="submit" @click="show=true" />
            </van-goods-action>
          </div>
        </van-panel>
      </div>
    </van-form>
    <!-- 选择支付方式 -->
    <van-popup v-model="show" position="bottom">
      <van-panel class="payment">
        <div slot="header" class="payment_header">
          支付方式
        </div>
        <div class="payment_content">
          <van-radio-group v-model="pays">
            <van-cell-group>
              <van-cell title="微信支付" clickable @click="radio='1'">
                <div slot="icon" class="payment_icon">
                  <img src="../../../assets/wx.png" alt="">
                </div>
                <van-radio checked-color="#F1452F" icon-size="1rem" slot="right-icon" name="1" />
              </van-cell>
              <van-cell title="支付宝支付" clickable @click="radio='2'">
                <div slot="icon" class="payment_icon">
                  <img src="../../../assets/zfb.png" alt="">
                </div>
                <van-radio checked-color="#F1452F" icon-size="1rem" slot="right-icon" name="2" />
              </van-cell>
              <van-cell title="银行卡支付" clickable @click="radio='3'">
                <div slot="icon" class="payment_icon">
                  <img src="../../../assets/yl.png" alt="">
                </div>
                <van-radio checked-color="#F1452F" icon-size="1rem" disabled slot="right-icon" name="3" />
              </van-cell>
            </van-cell-group>
          </van-radio-group>
          <div class="pays_btn">
            <button @click="submitPay(2)">确定</button>
          </div>
        </div>
      </van-panel>
    </van-popup>
    <!-- 对公转账 -->
    <van-popup v-model="duig" class="duig" position="bottom">
      <div class="duig-top">对公账户</div>
      <van-cell size="large">
        <div slot="title" class="duig-title">
          <div>开户名称：</div>
          <div>广州俱百家享租科技集团有限公司</div>
        </div>
      </van-cell>
      <van-cell size="large">
        <div slot="title" class="duig-title">
          <div>开户账户：</div>
          <div>3602073809100114062</div>
        </div>
      </van-cell>
      <van-cell size="large">
        <div slot="title" class="duig-title">
          <div>开户银行：</div>
          <div>中国工商银行广州泰沙路支行</div>
        </div>
      </van-cell>
      <div class="duig-foot">如果您打款成功，请联系客服 400-8722-000</div>
      <div class="duig-btn">
        <van-button round type="default" size="small" @click="duig=false">取消</van-button>
        <van-button round color="#f1452f" size="small" @click="submitPay(1)">确认</van-button>
      </div>
    </van-popup>
    <!-- 城市选择 -->
    <van-popup v-model="select" position="bottom" :style="{ 'max-height': '80%' }">
      <van-area :area-list="areaList" @confirm="areaOk" @cancel="select=false" />
    </van-popup>
  </div>
</template>

<script>
  import areaList from "@/assets/js/area.js"

  export default {
    data() {
      return {
        areaList,
        number: '',
        radio: '1',
        message: '',
        user: '',
        userCode: '',
        tel: '',
        address: '选择城市',
        city: '',
        select: false,
        list: [],
        listSelectArr: [],
        isNext: true,
        whole_id: [],
        lease: 0,
        total: 0,
        mortgage_total: 0,
        show: false,
        duig: false,
        pays: '1',
        values: {}
      }
    },
    created() {
      this.$axios.post(baseUrl + '/mobile/Whole/whole').then((res) => {
        if (res.data.code == 2) {
          for (let i = 0; i < res.data.data.length; i++) {
            this.list.push(res.data.data[i]);
            this.listSelectArr.push({
              curSelectIndex: 0
            })
          }
        }
      }).catch((err) => {
        console.log(err);
      })
    },
    methods: {
      //53客服
      _open53() {
        this.ismarker = false;
        this.marker = 0;
        let _53 = $53.createApi();
        _53.ush('cmd', 'mtalk');
        _53.query();
      },
      //选中地址
      areaOk(event) {
        this.address = '';
        for (var item in event) {
          this.address += event[item].name;
        }
        this.select = false;
      },
      //立即支付
      onSubmit(values) {
        values.whole_id = this.whole_id;
        values.house_area = this.number;
        values.mortgage_total = this.mortgage_total;
        values.total = this.total;
        values.month_total = this.lease;
        values.lease_year = this.radio;
        values.token = localStorage.getItem('Authorization');
        this.values = values;
      },
      //验证
      isNone() {
        if (this.user == '') {
          this.$toast('请填写联系人');
          return false;
        };
        if (this.tel == '') {
          this.$toast('请填联系方式');
          return false;
        };
        if (this.address == '选择城市') {
          this.$toast('请选择省市区');
          return false;
        };
        if (this.city == '') {
          this.$toast('请填写项目地址');
          return false;
        };
        if (this.userCode == '') {
          // this.$toast('请填写付款码');
          // return false;
          this.userCode = 'null';
          return true;
        };
        return true;
      },
      //提价订单
      submitPay(type) {

        if (this.isNone()) {
          const toast = this.$toast.loading({
            duration: 0,
            forbidClick: true,
            message: '提交中',
            loadingType: 'spinner'
          });
          this.values.is_channel = type;
          if (type == 2) {
            if (this.radio == '1') {
              this.$axios.post(baseUrl + '/mobile/WholeOrder/wholeOrderAdd', this.values).then((res) => {
                if (res.data.code == 19) {
                  //微信支付接口
                  window.location.href = baseUrl + '/mobile/Pay/wholeWapWxPay?out_trade_no=' + res.data.data;
                  this.$router.push({
                    path: '/wholeList',
                  })
                } else {
                  this.$toast.clear();
                  this.$toast(res.data.msg);
                }
              }).catch((err) => {
                console.log(err);
              })
            } else if (this.radio == '2') {
              this.$axios.post(baseUrl + '/mobile/WholeOrder/wholeOrderAdd', this.values).then((res) => {
                if (res.data.code == 19) {
                  //支付宝支付接口
                  window.location.href = baseUrl + '/mobile/Pay/wholeWapPay?out_trade_no=' + res.data.data;
                  this.$router.push({
                    path: '/wholeList',
                  })
                } else {
                  this.$toast.clear();
                  this.$toast(res.data.msg);
                }
              }).catch((err) => {
                console.log(err);
              })
            } else {
              this.$toast('暂不支持');
            }
          } else {
            this.$axios.post(baseUrl + '/mobile/WholeOrder/wholeOrderAdd', this.values).then((res) => {
              if (res.data.code == 19) {
                this.$toast('提交成功');
                this.duig = false;
              }
            }).catch((err) => {
              this.$toast.clear();
              this.$toast(res.data.msg);
            })
          }
        }
      },
      //下一步
      next() {
        this.lease = 0;
        this.whole_id = [];
        console.log(this.listSelectArr[0])
        if (this.listSelectArr[0].curSelectIndex || this.listSelectArr[0].curSelectIndex==0) {
          if (this.number !== '' && Number(this.number) >= 100) {
            for (let i in this.listSelectArr) {
              if (this.list[i].whole_category[this.listSelectArr[i].curSelectIndex] !== undefined) {
                this.lease += Number(this.list[i].whole_category[this.listSelectArr[i].curSelectIndex].price);
                this.whole_id.push(this.list[i].whole_category[this.listSelectArr[i].curSelectIndex].id);
              }
            }
            var params={
              total: this.lease,
              term: this.radio,
              house_area: this.number
            }
            this.$axios.post(baseUrl + '/mobile/Whole/wholePrice', {
              total: this.lease,
              term: this.radio,
              house_area: this.number
            }).then((res) => {
              if (res.data.code == 2) {
                this.total = res.data.data.total;
                this.mortgage_total = res.data.data.mortgage_total;
                this.isNext = false;
              }
            }).catch((err) => {
              console.log(123);
            })
          } else {
            this.$toast('房屋面积不能为空或者小于100');
            this.number = '';
          }
        } else {
          this.$toast('请选择家具选项');
        }
      },
      //是否选中
      isSelect(x, xs) {
        console.log(xs)
        // console.log(this.listSelectArr[x].curSelectIndex)
        // console.log(x)
        this.lease = 0;
        this.whole_id = [];
        this.$set(this.listSelectArr[x], 'curSelectIndex', xs);
      },
      //配置详情
      goDeploy(ids) {
        this.$router.push({
          path: '/Deploy',
          query: {
            id: ids
          }
        })
      }
    }
  }
</script>

<style scoped>
  @import 'wholeDetail.css';
</style>



// WEBPACK FOOTER //
// src/components/home/whole/wholeDetail.vue